<ngx-spinner
bdColor="rgba(51, 51, 51, 0.8)"
  template="<img class='loader-style-view' src='assets/images/abhi_loader.gif'  />"
  
>
</ngx-spinner>

<style>
@media (max-width: 768px) {
	 header {
		 width: 100%;
	}
}
 .row {
	 flex-wrap: nowrap !important;
	 margin: 0px !important;
}
 .marquee {
	 width: 100%;
	 padding: 3px 0;
	 background-color: #f7a500;
	 color: #000;
	 font-size: 16px;
	 font-family: PFHandbookPro-Regular;
}
 .top-header {
	 padding: 0 0% 0 5%;
	 display: flex;
	 background: #fff;
	 position: relative;
	 align-items: center;
	 height: 100%;
	 gap: 20px;
	 z-index: 1;
}
 .top-header img {
	 max-width: 100px;
}
 .top-header .right-wrapper {
	 height: 55px;
	 background-color: #c91429;
	 border-radius: 0 0 0 14px;
	 display: flex;
	 flex: 1;
	 height: 64px;
	 justify-content: space-between;
	 align-items: center;
	 padding: 0 2% 0 0;
	 margin-bottom: 0px;
}
 .bottom-header {
	 padding: 10px 5%;
	 border-top: 1px solid #ccc;
	 background: #fff;
	 position: relative;
	 border-bottom: 1px solid #ccc;
}
 .bottom-header p {
	 font-size: 15px;
	 line-height: 20px;
	 letter-spacing: 0em;
	 text-align: left;
	 color: #c91429;
	 font-family: dev_med;
	 margin-bottom: 0;
}
</style>
<header>
    <div class="top-header">
       <img src="assets/images/ABHI-logo.jpg"/>
       <ul class="right-wrapper"></ul>
    </div>
    <div class="bottom-header">
        <p style="cursor: default;">Aditya Birla Health Insurance Co. Limited</p>
    </div>
</header>
  <div class="container mt-2">
    <div class="content">
      <iframe 
        *ngIf="iframeUrl" 
        [src]="iframeUrl" 
       style="border: 1px solid #CCC; min-height: 700px; position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%; border: none;"
        (load)="onIframeLoad()">
      </iframe>
    </div>
  </div>
  